import {INavItem} from './interfaces';
import {Pages, RoutesUrl} from '../../utils/constants/routeConstants';

import Chat from 'assets/image/menu-auth/chat.svg';
import Xpedition from 'assets/image/menu-auth/xpedition.png';
import Backpack from 'assets/image/menu-auth/favorites.png';
import Library from 'assets/image/menu-auth/library.png';
import Materials from 'assets/image/menu-auth/share.png';
import Resource from 'assets/image/menu-auth/resources.png';
import Referrals from 'assets/image/menu-auth/referrals.png';
import Search from 'assets/image/menu-auth/search.png';
import Journal from 'assets/image/menu-auth/jun_journal.png';
import Review from 'assets/image/menu-auth/jun_reviews.png';
import JunResource from 'assets/image/menu-auth/jun_resources.png';
import Chatroom from 'assets/image/menu-auth/jun_chatroom.png';
import Training from 'assets/image/menu-auth/training.svg';
import Statistics from 'assets/image/menu-auth/pieChart.png';

export const navItems: INavItem[] = [
  {
    index: 1,
    name: Pages.Chat,
    path: RoutesUrl.Chat,
    title: 'Chat',
    image: Chat
  },
  {
    index: 2,
    name: Pages.Xpedition,
    path: RoutesUrl.Xpeditions,
    title: 'Xpedition'
  },
  {
    index: 3,
    name: Pages.Backpack,
    path: RoutesUrl.Backpack,
    title: 'Backpack'
  },
  {
    index: 4,
    name: Pages.Share,
    path: RoutesUrl.Materials,
    title: 'Materials',
    image: Materials
  },
  {
    index: 5,
    name: Pages.Library,
    path: RoutesUrl.Library,
    title: 'Library'
  },
  {
    index: 6,
    name: Pages.Dialogues,
    path: RoutesUrl.Dialogues,
    title: 'Dialogues',
    image: Chat
  },
  {
    index: 7,
    name: Pages.Exercises,
    path: RoutesUrl.Exercise,
    title: 'Exercises',
    image: Xpedition
  },
  {
    index: 8,
    name: Pages.CmResource,
    path: RoutesUrl.CmResource,
    title: 'Resource',
    image: Library
  },
  {
    index: 9,
    name: Pages.Referrals,
    path: RoutesUrl.Referrals,
    title: 'Referrals',
    image: Referrals
  },
  {
    index: 10,
    name: Pages.Search,
    path: RoutesUrl.Search,
    title: 'Search',
    image: Search
  },
  {
    index: 11,
    name: Pages.Journals,
    path: RoutesUrl.Journals,
    title: 'Journals',
    image: Chat
  },
  {
    index: 12,
    name: Pages.Reviews,
    path: RoutesUrl.Reviews,
    title: 'Reviews',
    image: Review
  },
  {
    index: 13,
    name: Pages.Resource,
    path: RoutesUrl.Resource,
    title: 'Resource',
    image: JunResource
  },
  {
    index: 14,
    name: Pages.Chatroom,
    path: RoutesUrl.Chatroom,
    title: 'Chatroom',
    image: Chat
  },
  {
    index: 15,
    name: Pages.Trainings,
    path: RoutesUrl.Trainings,
    title: 'Trainings',
    image: Training
  },
  {
    index: 16,
    name: Pages.Statistics,
    path: RoutesUrl.Statistics,
    title: 'Statistics',
    image: Statistics
  },
  {
    index: 17,
    name: Pages.Statistics,
    path: RoutesUrl.Statistics,
    title: 'Statistics',
    image: Statistics
  },
  {
    index: 18,
    name: Pages.AllStatistics,
    path: RoutesUrl.AllStatistics,
    title: 'Statistics',
    image: Statistics
  },
  {
    index: 19,
    name: Pages.Sessions,
    path: RoutesUrl.Sessions,
    title: 'Sessions',
    image: Xpedition
  },
  {
    index: 20,
    name: Pages.Activities,
    path: RoutesUrl.Activities,
    title: 'My Activities',
    image: Xpedition
  },
  {
    index: 21,
    name: Pages.DmResource,
    path: RoutesUrl.DmResource,
    title: 'Resource'
  }
];
